// Admin page wrapper 

import { Outlet } from 'react-router-dom';

const AdminLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-yap-bg text-white selection:bg-yap-primary selection:text-black font-sans relative overflow-x-hidden">
      {/* Ambient Background Effects */}
      <div className="fixed top-[-20%] left-[20%] w-[600px] h-[600px] bg-yap-primary/5 rounded-full blur-[120px] pointer-events-none z-0" />
      <div className="fixed bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-emerald-500/5 rounded-full blur-[100px] pointer-events-none z-0" />
      
      {/* Main Content Area */}
      <main className="relative z-10">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;

